module.exports = __webpack_public_path__ + "img/v1.1.e774f5f3.png";